import BodyView from "@/layout/BodyView.vue";

import Profile from "@/pages/users/profile/Index.vue";
import Email from "@/pages/users/email/Index.vue";

export const route = 

{
  path: "/users",
  component: BodyView,
  children: [
    {
      path: "profile",
      name: "profile",
      component: Profile,
      meta: {
        title: 'Profile | INDOFORCETECH',
      }
    },
    {
      path: "mail",
      name: "mail",
      component: Email,
      meta: {
        title: 'Mail | INDOFORCETECH',
      }
    }
  ]
}